import File from '@/views/PdfFile'

export default [
    {
        path: '/files/:id',
        component: File,
    },
]